import { render, staticRenderFns } from "./Embed.vue?vue&type=template&id=5c8e34b6&scoped=true"
import script from "./Embed.vue?vue&type=script&lang=ts"
export * from "./Embed.vue?vue&type=script&lang=ts"
import style0 from "./Embed.vue?vue&type=style&index=0&id=5c8e34b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8e34b6",
  null
  
)

export default component.exports